<template>
  <div>
    <div v-if="isPrivate" class="notebook-notice">
      <ion-icon name="lock"></ion-icon>
      This notebook is private. You won't be able to see it's content.
    </div>
    <div v-else :class="readingStyle" padding>
      <div>
        <h1 class="digest-title">
          {{ title }}
        </h1>
        <div v-if="author" class="digest-subinfo">
          <div style="margin-right: 0.5em; padding-top: 0.3em">
            <ion-icon style="margin-right: 0.2em" name="contact"></ion-icon
            ><span v-if="author">{{ author }}</span>
          </div>
        </div>
        <div v-if="options.length > 0" class="digest-subinfo">
          <div style="margin-right: 0.5em; padding-top: 0.3em">
            <ion-icon style="margin-right: 0.2em" name="bookmark"></ion-icon
            ><span v-if="category">{{ showCategory }}</span>
          </div>
          <div style="margin-right: 0.5em; padding-top: 0.3em">
            <ion-icon
              style="margin-right: 0.2em"
              :name="isPublic == 0 ? 'eye-off' : 'eye'"
            ></ion-icon
            ><span v-if="isPublic == 0">Private</span><span v-else>Public</span>
          </div>
          <div style="margin-right: 0.5em; padding-top: 0.3em">
            <ion-icon style="margin-right: 0.2em" name="calendar"></ion-icon
            ><span v-if="created">{{ formatDate(created) }}</span>
          </div>
        </div>
      </div>
      <hr class="title-hr" />
      <div class="rendered allow-select" ref="rendered" v-html="rendered"></div>
    </div>

    <div v-if="popupContent">
      <div id="popupMenu" style="display: none">
        <popup-menu></popup-menu>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from "date-fns";
import marked from "marked";
import Menu from "./PopupMenu";

export default {
  data() {
    return {
      popupContent: false,
      id: "",
      title: "",
      content: "",
      rendered: "",
      options: [],
      category: 1,
      created: null,
      isPublic: 0,
      isPrivate: false,
      author: "",
    };
  },

  computed: {
    readingStyle() {
      return [
        "reading-" +
          (this.$store.state.settings.settings.readingMode || "normal"),
        "textsize-" +
          (this.$store.state.settings.settings.textSize || "normal"),
      ];
    },
    showCategory() {
      if (this.category) {
        let idx = this.options.findIndex((x) => x.value == this.category);
        if (idx < 0) {
          idx = 0;
        }
        return this.options[idx].label;
      }
      return 1;
    },
  },

  methods: {
    async load(id) {
      this.id = id;

      if (this.id) {
        var res = await this.$lawyerly.casebooks.view({
          id: this.id,
          docType: "note",
          docId: 0,
        });
        if (res.data) {
          if (res.data.isPrivate) {
            this.isPrivate = true;
            return;
          }
          if (res.data.count) {
            var note = res.data.result[0];

            this.title = note.title || "Untitled";
            this.content = note.content || "Write...";

            this.content = this.content.replace(/\/juris\/view\//g, "case://");
            this.content = this.content.replace(/\/laws\/view\//g, "law://");

            this.rendered = marked(this.content);
            this.created = note.created_at;
            this.category = note.category ? note.category : 1;
            this.isPublic = note.public;
            this.author = note.author;

            if (!note.author) {
              if (note.public == 1) {
                this.$store.commit("ui/setMoreHeaderButtons", {
                  mobile: [
                    { icon: "create", emit: "header-command", cmd: "edit" },
                    // { icon: "more", emit: "header-command", cmd: "more" }
                  ],
                  web: [
                    {
                      label: "share",
                      icon: "share",
                      disabled: false,
                      emit: "header-command",
                      cmd: "share",
                    },
                    {
                      label: "edit",
                      icon: "create",
                      disabled: false,
                      emit: "header-command",
                      cmd: "edit",
                    },
                  ],
                });
              } else {
                this.$store.commit("ui/setMoreHeaderButtons", {
                  mobile: [
                    { icon: "create", emit: "header-command", cmd: "edit" },
                    // { icon: "more", emit: "header-command", cmd: "more" }
                  ],
                  web: [
                    {
                      label: "edit",
                      icon: "create",
                      disabled: false,
                      emit: "header-command",
                      cmd: "edit",
                    },
                  ],
                });
              }
            } else {
              this.$store.commit("ui/setMoreHeaderButtons", {
                mobile: [
                  // { icon: "create", emit: "header-command", cmd: "edit" },
                  // { icon: "more", emit: "header-command", cmd: "more" }
                ],
                web: [
                  {
                    label: "share",
                    icon: "share",
                    disabled: false,
                    emit: "header-command",
                    cmd: "share",
                  },
                ],
              });
            }

            setTimeout(() => {
              this.$root.morphLinks(this.$refs.rendered);
            }, 500);

            this.$root.mountPrintable(this.title, this.rendered, 'Casebook');
          }
        }
      }
    },

    formatDate(d) {
      return format(new Date(d), "MMM. dd, yyyy hh:mm a");
    },

    edit() {
      this.$router.push("/notebooks/edit/" + this.id);
    },

    more(evt) {
      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(evt, {
          template: "popupMenu",
          translucent: true,
        });
      }, 200);
    },

    share() {
      var url = `${this.$config.api.domain}/#/notebooks/${this.id}`;
      shareTo(url, "Share this notebook with your friends.");
    },

    onHeaderCommand(event, cmd) {
      switch (cmd.cmd) {
        case "more":
          this.more(event);
          break;
        case "edit":
          this.edit();
          break;
        case "share":
          this.share();
          break;
      }
    },

    async getCategories() {
      const opts = [
        { label: "Uncategorized", value: 1 },
        { label: "Political Law", value: 2 },
        { label: "Labor Law", value: 3 },
        { label: "Civil Law", value: 4 },
        { label: "Taxation Law", value: 5 },
        { label: "Commercial Law", value: 6 },
        { label: "Criminal Law", value: 7 },
        { label: "Remedial Law", value: 8 },
        { label: "Legal Ethics", value: 9 },
        { label: "Others", value: 10 },
      ];

      const res = await this.$http({
        method: "GET",
        url: this.$config.api.url + "/categories",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (res) {
        if (res.data) {
          if (res.data.result.length > 0) {
            const categories = res.data.result;
            categories.forEach((el) => {
              if (el.parent) {
                const idx = opts.findIndex((x) => x.value === el.parent);
                opts.splice(idx + 1, 0, {
                  label: el.title,
                  value: el.id,
                  parent: el.parent,
                });
              } else {
                opts.push({ label: el.title, value: el.id });
              }
            });
          }
        }
      }
      this.options = opts;
    },
  },

  mounted() {
    this.load(this.$store.state.route.params.id);

    this.getCategories();
    // this.$store.commit("ui/setMoreHeaderButtons", {
    //   mobile: [
    //     { icon: "create", emit: "header-command", cmd: "edit" },
    //     // { icon: "more", emit: "header-command", cmd: "more" }
    //   ],
    //   web: [
    //     { label: "edit", icon: "create", disabled: false, emit: "header-command", cmd: "edit" }
    //   ]
    // });
    this.$root.$on("header-command", this.onHeaderCommand);
    window.showPrinciples = async (index, id) => {
      const el = document.getElementById(`principle-${index}`);
      let sh = 0;

      if (el.classList.contains("active")) {
        el.className = "data";
        el.style.height = "0";
      } else {
        el.className = "data active";
        sh = el.scrollHeight;
        el.style.height = sh + "px";
      }
    };
  },

  beforeDestroy() {
    this.$root.unMountPrintable();
    window.addEventListener("beforeprint", this.renderPrintable);
    window.addEventListener("afterprint", this.removePrintable);
    this.$store.commit("ui/setMoreHeaderButtons", { mobile: [], web: [] });
    this.$root.$off("header-command", this.onHeaderCommand);
  },

  components: {
    "popup-menu": Menu,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/render.scss";
@import "~simplemde/dist/simplemde.min.css";
@import "~github-markdown-css";
</style>
<style>
.rendered > h1:first-child {
  color: #18bc9c;
  font-weight: 800;
}

.rendered .icons {
  padding: 0 0.3em;
  vertical-align: middle;
  cursor: pointer;
}

.rendered .icons:active svg {
  fill: rgb(117, 59, 189);
}

.notebook-principle-text {
  color: #505966;
  background-color:rgba(180,120,255,0.35);
}

.notebook-highlight-text {
  color: #505966;
  background-color:rgba(255,255,0,0.35);
}


.rendered .data {
  background: #f0f0f0;
  overflow: hidden;
  transition: height 0.3s ease-out;
}

.rendered .data ion-spinner {
  vertical-align: middle;
  height: 1.2em;
}

.rendered .icons svg {
  fill: #a1a1a1;
}

.rendered .icons.case.enable svg {
  fill: rgb(180, 120, 255);
}

.rendered .icons.law.enable svg {
  fill: #f1c40f;
}
</style>
